<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-row>
        <v-col cols="12">
          <GradeClassStudentSelect
            disableGradeSelect
            @changed="gradeClassStudentChange"
            :autoSyncClassByStudent="false"
          />
        </v-col>
      </v-row>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" style="background-color: white" color="#0D47A1" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { get } from 'lodash'
import GradeClassStudentSelect from '@/components/basic/filter/GradeClassStudentSelect.vue'

export default {
  components: {
    GradeClassStudentSelect
  },
  data: () => ({
    selectedClass: {},
    selectedStudent: {}
  }),
  computed: {
    ...mapGetters('constant', ['messageMemberType']),

    currentClassId() {
      return { currentClass: get(this.classData, 'id') }
    }
  },
  methods: {
    gradeClassStudentChange(data) {
      this.selectedClass = { ...data.class }
      this.selectedStudent = { ...data.student }
    },
    onFilterChanged() {
      const params = {
        class: get(this.selectedClass, 'id'),
        student: get(this.selectedStudent, 'id')
      }
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
